<template>
  <b-form-group
    label="Hesap Durumu"
    label-for="status"
  >
    <validation-provider
      #default="{ errors }"
      name="Hesap Durumu"
      rules="required"
    >
      <v-select
        id="status"
        v-model="dataItem.status"
        :options="statuses"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  name: 'UserStatus',
  components: {
    ValidationProvider,
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['drUsers/dataItem']
    },
    statuses() {
      return [
        {
          id: '1',
          title: 'Aktif',
        },
        {
          id: '0',
          title: 'Pasif',
        },
      ]
    },
  },
}
</script>
